export default "__VITE_ASSET__CVc8kjZJ__"